import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { cloneDeep, get } from "lodash";
import AdwordsImage from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/adwardsLogoWhiteBg.png";
import MetaImage from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/metaLogoWhiteBg.png";
import DV360Image from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/dv360LogoWhiteBg.png";
import IonImage from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/ionLogoWhiteBg.png";
import ViImage from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/vodafone.png";
import "./creative.scss";
import { withRouter } from "react-router-dom";
import asyncRoute from "../../../../../helpers/hoc/asyncRoute";
import {
  platformConfig,
  enumDataStrategyCreative,
  dataStrategy,
} from "./constant";

import {
  getPayloadStrategyCreative,
  isStrategyCreativeDataValid,
  checkIfEmptyPlatform,
  isCreativeAdd,
} from "./helpers/strategyCreativeHelper";

import { useFetchPlatformData } from "../../../../../hooks/useFetchPlatformData";
import { useFetchMediaListData } from "../../../../../hooks/useFetchMediaListData";

const AddCreativeModal = asyncRoute(() => import("./AddCreativeModal"));
const ViewCreativeModal = asyncRoute(() => import("./viewCreativeModal"));
const AccordianCreative = asyncRoute(() => import("./AccordianCreative"));
const UtmModal = asyncRoute(() => import("./UTM"));

const platfomRenderData = {
  [enumDataStrategyCreative.ads.key]: {
    key: enumDataStrategyCreative.ads.key,
    logo: AdwordsImage,
    title: platformConfig.google,
  },
  [enumDataStrategyCreative.meta.key]: {
    key: enumDataStrategyCreative.meta.key,
    logo: MetaImage,
    title: platformConfig.meta,
  },
  [enumDataStrategyCreative.dv360.key]: {
    key: enumDataStrategyCreative.dv360.key,
    logo: DV360Image,
    title: platformConfig.dv360,
  },
  [enumDataStrategyCreative.ion.key]: {
    key: enumDataStrategyCreative.ion.key,
    logo: IonImage,
    title: platformConfig.ion,
  },
  [enumDataStrategyCreative.viads.key]: {
    key: enumDataStrategyCreative.viads.key,
    logo: ViImage,
    title: platformConfig.viads,
  },
  [enumDataStrategyCreative.ioh.key]: {
    key: enumDataStrategyCreative.ioh.key,
    logo: IonImage,
    title: platformConfig.ioh,
  },
};

// this is static media type used for mapping through state data array ************************
const staticMediaType = [
  { key: 0, value: "search" },
  { key: 1, value: "display" },
  { key: 2, value: "video" },
];
// **********************************************************************************************

const Creative = (props) => {
  const reduxStrategyData = useSelector((state) =>
    get(state, "app.strategyCreativeData", "")
  );
  // console.log(props, 'PROPS');
  const reduxDataForPlatform = useFetchPlatformData();

  const reduxMediaListData = useFetchMediaListData();

  // const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState({
    openCreativeModal: false,
    openViewModal: false,
  });
  const [openUtmModal, setOpenUtmModal] = useState(false);
  const [utmData, setUtmData] = useState({
    utmKeyData: "",
    platformType: "",
    creativeType: "",
    strategyIndex: -1,
  });

  const [strategyCreativeData, setStrategyCreativeData] = useState(
    reduxStrategyData ? reduxStrategyData : {}
  );

  const [selectedPlatformData, setSelectedPlatFormData] = useState({
    strategyId: -1,
    platformType: {},
    creativeType: "",
    creativeData: {},
    isGlobalCreativePage: false,
    isPlatFormVisible: false, // set this to true for add new creative from global creative screen *********
  });

  const [creativeData, setCreativeData] = useState({});

  useEffect(() => {
    initialApiCall();
  }, []);

  useEffect(() => {
    const isValidStrategyData = isStrategyCreativeDataValid(
      strategyCreativeData,
      staticMediaType
    );
    if (
      isValidStrategyData &&
      Array.isArray(reduxDataForPlatform) &&
      Array.isArray(reduxMediaListData) &&
      reduxDataForPlatform.length > 0 &&
      reduxMediaListData.length > 0
    ) {
      const payloadForStrategy = getPayloadStrategyCreative(
        strategyCreativeData,
        reduxMediaListData,
        reduxDataForPlatform
      );

      const isAddApi = isCreativeAdd(reduxStrategyData);

      props.setCreativePayloadDetails({
        valid: true,
        data: payloadForStrategy,
        dataForRedux: cloneDeep(strategyCreativeData),
        isAddApi: isAddApi,
      });
    } else {
      props.setCreativePayloadDetails({
        valid: false,
        data: {},
        isAddApi: true,
      });
    }
  }, [strategyCreativeData, reduxDataForPlatform, reduxMediaListData]);

  const initialApiCall = async () => {};

  const handleApplyCheckboxSelect = ({
    selectedValues,
    creativeType,
    platformType,
    selectedStrategyIndex,
  }) => {
    setStrategyCreativeData((prevState) => ({
      ...prevState,
      [platformType]: {
        ...prevState[platformType],
        [creativeType]: prevState[platformType][creativeType].map(
          (item, index) => {
            if (index == selectedStrategyIndex) {
              let creativePrevData = [
                ...cloneDeep(item.creatives),
                ...selectedValues,
              ];
              return { ...item, creatives: creativePrevData };
            } else {
              return item;
            }
          }
        ),
      },
    }));
  };

  const handleRemoveCreative = ({
    id,
    creativeType,
    platformType,
    selectedStrategyIndex,
    creativeIndex,
  }) => {
    setStrategyCreativeData((prevState) => ({
      ...prevState,
      [platformType]: {
        ...prevState[platformType],
        [creativeType]: prevState[platformType][creativeType].map(
          (item, index) => {
            if (index == selectedStrategyIndex) {
              return {
                ...item,
                creatives: item.creatives.filter(
                  (data, index) => index != creativeIndex
                ),
              };
            } else {
              return item;
            }
          }
        ),
      },
    }));
  };

  const handleAddCreativeData = ({ platformDataToSet, creativeData }) => {
    const platFormKey = platformDataToSet.platformType.enumKey;
    const creativeKey = platformDataToSet.creativeType;
    let strategyInx = platformDataToSet.strategyIndex;
    let clonedCreativeData = cloneDeep(
      strategyCreativeData[platFormKey][creativeKey][strategyInx].creatives
    );
    if (creativeKey == enumDataStrategyCreative.searchKey) {
      const modifiedCreativeData = {
        landingUrl: creativeData.landingUrl,
        heading: creativeData.headingData.map(
          (dataHeading) => dataHeading.heading
        ),
        description: creativeData.descriptionData.map(
          (dataDesc) => dataDesc.description
        ),
      };
      clonedCreativeData = [modifiedCreativeData];
    } else {
      clonedCreativeData.push(creativeData);
    }

    setStrategyCreativeData((prevState) => ({
      ...prevState,
      [platFormKey]: {
        ...prevState[platFormKey],
        [creativeKey]: prevState[platFormKey][creativeKey].map(
          (item, index) => {
            if (index == strategyInx) {
              return { ...item, creatives: clonedCreativeData };
            } else {
              return item;
            }
          }
        ),
      },
    }));
    toggleCreativeModal(true);
  };

  const setPlatFormSelectedData = ({
    platformType = "",
    strategyIndex = -1,
    creativeType = "",
  }) => {
    let searchCreativeData = [];
    let findPlatForm = reduxDataForPlatform.find(
      (dataPlat) =>
        dataPlat.value.toLowerCase() ==
        (platformType == enumDataStrategyCreative.ads.key
          ? platformConfig.google.toLowerCase()
          : platformType.toLowerCase())
    );
    findPlatForm["enumKey"] =
      platformType == enumDataStrategyCreative.ads.key
        ? enumDataStrategyCreative.ads.key
        : platformType.toLowerCase();
    if (creativeType == enumDataStrategyCreative.searchKey) {
      searchCreativeData = cloneDeep(
        strategyCreativeData[findPlatForm["enumKey"]][creativeType][
          strategyIndex
        ].creatives
      );
    }
    setSelectedPlatFormData({
      strategyIndex: strategyIndex,
      platformType: findPlatForm,
      creativeType: creativeType,
      creativeData: searchCreativeData.length > 0 ? searchCreativeData[0] : {},
      isGlobalCreativePage: false,
      isPlatFormVisible: false,
    });
  };

  const toggleCreativeModal = (clearSeletedPlatForm = false) => {
    setOpenModal({
      ...openModal,
      openCreativeModal: !openModal.openCreativeModal,
    });
    if (clearSeletedPlatForm) {
      setSelectedPlatFormData({});
    }
  };

  const toogleUtmModal = ({
    utmData = {},
    setUtm = false,
    setUtmInStrategyData = false,
  }) => {
    if (setUtm) {
      setUtmData(utmData);
    }
    if (setUtmInStrategyData) {
      let strategyData = cloneDeep(
        strategyCreativeData[utmData.platformType][utmData.creativeType][
          utmData.strategyIndex
        ]
      );
      strategyData["utm"] = utmData.utmKeyData;
      setStrategyCreativeData((prevState) => ({
        ...prevState,
        [utmData.platformType]: {
          ...prevState[utmData.platformType],
          [utmData.creativeType]: prevState[utmData.platformType][
            utmData.creativeType
          ].map((item, index) => {
            if (index == utmData.strategyIndex) {
              return strategyData;
            } else {
              return item;
            }
          }),
        },
      }));
    }
    setOpenUtmModal(!openUtmModal);
  };

  const toggleViewCreativeModal = () => {
    setOpenModal({ ...openModal, openViewModal: !openModal.openViewModal });
  };

  const handleViewCreative = ({ creativeData = {} }) => {
    setCreativeData(creativeData);
    toggleViewCreativeModal();
  };

  // console.log(strategyCreativeData, "**********************");

  return (
    <div>
      {openModal.openViewModal && (
        <ViewCreativeModal
          openViewModal={openModal.openViewModal}
          creativeData={creativeData}
          toggleViewCreativeModal={toggleViewCreativeModal}
        />
      )}

      {openModal.openCreativeModal && (
        <AddCreativeModal
          openCreativeModal={openModal.openCreativeModal}
          toggleCreativeModal={toggleCreativeModal}
          platFormData={reduxDataForPlatform ? reduxDataForPlatform : []}
          mediaListData={reduxMediaListData ? reduxMediaListData : []}
          selectedPlatformData={selectedPlatformData}
          handleAddCreativeData={handleAddCreativeData}
          routerProps={props}
        />
      )}

      {openUtmModal && (
        <UtmModal
          openUtmModal={openUtmModal}
          strategyUtmData={utmData}
          toogleUtmModal={toogleUtmModal}
          isViewCampaign={props.isViewCampaign}
        />
      )}

      {Object.keys(strategyCreativeData).map((data, index) => {
        return (
          <React.Fragment key={index}>
            {!checkIfEmptyPlatform(
              strategyCreativeData,
              platfomRenderData[data].key,
              staticMediaType
            ) && (
              <AccordianCreative
                accordianLogo={platfomRenderData[data].logo}
                accordianTitle={platfomRenderData[data].title}
                accordianIndex={index}
                strategyCreativeData={
                  strategyCreativeData[platfomRenderData[data].key]
                }
                platformType={platfomRenderData[data].key}
                handleApplyCheckboxSelect={handleApplyCheckboxSelect}
                handleRemoveCreative={handleRemoveCreative}
                toggleCreativeModal={toggleCreativeModal}
                setPlatFormSelectedData={setPlatFormSelectedData}
                toogleUtmModal={toogleUtmModal}
                handleViewCreative={handleViewCreative}
                isViewCampaign={props.isViewCampaign}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default withRouter(Creative);
